/* @generated from adl module ferovinum.app.contract */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';

export type ContractKind = 'stock' | 'invoice';
export const valuesContractKind : ContractKind[] = ['stock', 'invoice'];

const ContractKind_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"Discriminates which subtype table a contract leg is backed by.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock","default":{"kind":"nothing"},"name":"stock","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"invoice","default":{"kind":"nothing"},"name":"invoice","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ContractKind","version":{"kind":"nothing"}}};

export const snContractKind: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractKind"};

export function texprContractKind(): ADL.ATypeExpr<ContractKind> {
  return {value : {typeRef : {kind: "reference", value : snContractKind}, parameters : []}};
}

/**
 * A funding agreement between a Ferovinum entity and a counterparty.
 */
export interface ContractLeg {
  kind: ContractKind;
  /**
   * The Ferovinum legal entity that is party to this contract leg.
   */
  feroEntity: ferovinum_app_db.FeroEntity;
  /**
   * The counterparty organisation.
   */
  counterpartyId: ferovinum_app_db.OrganisationId;
  /**
   * The master agreement version in force, snapshotted from the deal at creation. Drives the
   * accruing fee's rate-sampling regime (PERIOD_START / PERIOD_AVERAGE / PERIOD_END); lives on the
   * leg rather than per terms version so it can't drift across revisions. Existing rows backfill to MTA_LEGACY.
   */
  mtaVersion: ferovinum_app_db.MasterAgreementVersion;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeContractLeg(
  input: {
    kind: ContractKind,
    feroEntity: ferovinum_app_db.FeroEntity,
    counterpartyId: ferovinum_app_db.OrganisationId,
    mtaVersion: ferovinum_app_db.MasterAgreementVersion,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): ContractLeg {
  return {
    kind: input.kind,
    feroEntity: input.feroEntity,
    counterpartyId: input.counterpartyId,
    mtaVersion: input.mtaVersion,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const ContractLeg_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE contract_leg ADD CONSTRAINT contract_leg_id_kind_uniq UNIQUE (id, kind);","CREATE TRIGGER contract_leg_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON contract_leg\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["counterpartyId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A funding agreement between a Ferovinum entity and a counterparty.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractKind"}},"parameters":[]}},{"annotations":[{"value":"The Ferovinum legal entity that is party to this contract leg.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[{"value":"The counterparty organisation.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"counterpartyId","default":{"kind":"nothing"},"name":"counterpartyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[{"value":"'MTA_LEGACY'::text","key":{"moduleName":"common.db","name":"DbDefault"}},{"value":"The master agreement version in force, snapshotted from the deal at creation. Drives the\naccruing fee's rate-sampling regime (PERIOD_START / PERIOD_AVERAGE / PERIOD_END); lives on the\nleg rather than per terms version so it can't drift across revisions. Existing rows backfill to MTA_LEGACY.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"mtaVersion","default":{"kind":"nothing"},"name":"mtaVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MasterAgreementVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ContractLeg","version":{"kind":"nothing"}}};

export const snContractLeg: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractLeg"};

export function texprContractLeg(): ADL.ATypeExpr<ContractLeg> {
  return {value : {typeRef : {kind: "reference", value : snContractLeg}, parameters : []}};
}

export type ContractLegId = common_db.DbKey<ContractLeg>;

const ContractLegId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLeg"}},"parameters":[]}]}}},"name":"ContractLegId","version":{"kind":"nothing"}}};

export const snContractLegId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractLegId"};

export function texprContractLegId(): ADL.ATypeExpr<ContractLegId> {
  return {value : {typeRef : {kind: "reference", value : snContractLegId}, parameters : []}};
}

export type ContractStatus = 'active' | 'voided';
export const valuesContractStatus : ContractStatus[] = ['active', 'voided'];

const ContractStatus_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"Lifecycle status of a contract leg. ACTIVE is the implicit default (no status row); a terminal\nstatus is recorded by appending a row to contract_leg_status rather than mutating the leg, so the\nleg stays immutable.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"active","default":{"kind":"nothing"},"name":"active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"voided","default":{"kind":"nothing"},"name":"voided","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ContractStatus","version":{"kind":"nothing"}}};

export const snContractStatus: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractStatus"};

export function texprContractStatus(): ADL.ATypeExpr<ContractStatus> {
  return {value : {typeRef : {kind: "reference", value : snContractStatus}, parameters : []}};
}

/**
 * Append-only status record for a contract leg. The leg's current status is the latest row (ACTIVE
 * when none exists). VOIDED is written when an upload is abandoned (fero-void / cancel) after the
 * note signs — a voided leg is excluded from fee accrual and valuation so it accrues nothing.
 */
export interface ContractLegStatus {
  contractLegId: ContractLegId;
  status: ContractStatus;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeContractLegStatus(
  input: {
    contractLegId: ContractLegId,
    status: ContractStatus,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): ContractLegStatus {
  return {
    contractLegId: input.contractLegId,
    status: input.status,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const ContractLegStatus_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["CREATE TRIGGER contract_leg_status_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON contract_leg_status\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["contractLegId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"Append-only status record for a contract leg. The leg's current status is the latest row (ACTIVE\nwhen none exists). VOIDED is written when an upload is abandoned (fero-void / cancel) after the\nnote signs — a voided leg is excluded from fee accrual and valuation so it accrues nothing.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ContractLegStatus","version":{"kind":"nothing"}}};

export const snContractLegStatus: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractLegStatus"};

export function texprContractLegStatus(): ADL.ATypeExpr<ContractLegStatus> {
  return {value : {typeRef : {kind: "reference", value : snContractLegStatus}, parameters : []}};
}

export type ContractLegStatusId = common_db.DbKey<ContractLegStatus>;

const ContractLegStatusId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegStatus"}},"parameters":[]}]}}},"name":"ContractLegStatusId","version":{"kind":"nothing"}}};

export const snContractLegStatusId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractLegStatusId"};

export function texprContractLegStatusId(): ADL.ATypeExpr<ContractLegStatusId> {
  return {value : {typeRef : {kind: "reference", value : snContractLegStatusId}, parameters : []}};
}

/**
 * Immutable identity of a `kind=stock` leg; economics live in [StockContractLegEconomics].
 */
export interface StockContractLeg {
  contractLegId: ContractLegId;
  productId: ferovinum_app_db.ProductId;
  /**
   * The deal leg this stock contract leg funds. Nullable: a leg can be created
   * before its deal leg is allocated.
   */
  dealLegId: (ferovinum_app_db.DealLegId|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeStockContractLeg(
  input: {
    contractLegId: ContractLegId,
    productId: ferovinum_app_db.ProductId,
    dealLegId: (ferovinum_app_db.DealLegId|null),
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): StockContractLeg {
  return {
    contractLegId: input.contractLegId,
    productId: input.productId,
    dealLegId: input.dealLegId,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const StockContractLeg_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE stock_contract_leg ADD COLUMN kind text NOT NULL DEFAULT 'stock' CHECK (kind = 'stock');","ALTER TABLE stock_contract_leg ADD CONSTRAINT stock_contract_leg_contract_leg_id_kind_fk FOREIGN KEY (contract_leg_id, kind) REFERENCES contract_leg(id, kind);","CREATE TRIGGER stock_contract_leg_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON stock_contract_leg\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["dealLegId"],["productId"]],"uniquenessConstraints":[["contractLegId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"Immutable identity of a `kind=stock` leg; economics live in [StockContractLegEconomics].\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[{"value":"The deal leg this stock contract leg funds. Nullable: a leg can be created\nbefore its deal leg is allocated.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"StockContractLeg","version":{"kind":"nothing"}}};

export const snStockContractLeg: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"StockContractLeg"};

export function texprStockContractLeg(): ADL.ATypeExpr<StockContractLeg> {
  return {value : {typeRef : {kind: "reference", value : snStockContractLeg}, parameters : []}};
}

/**
 * A stock leg's revisable economics, one row per version — a revision appends, never mutates.
 */
export interface StockContractLegEconomics {
  contractLegId: ContractLegId;
  version: number;
  purchasePrice: common.BigDecimal;
  stockQuantity: common.BigDecimal;
  /**
   * Absolute amount, not a rate.
   */
  reserve: common.BigDecimal;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeStockContractLegEconomics(
  input: {
    contractLegId: ContractLegId,
    version: number,
    purchasePrice: common.BigDecimal,
    stockQuantity: common.BigDecimal,
    reserve: common.BigDecimal,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): StockContractLegEconomics {
  return {
    contractLegId: input.contractLegId,
    version: input.version,
    purchasePrice: input.purchasePrice,
    stockQuantity: input.stockQuantity,
    reserve: input.reserve,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const StockContractLegEconomics_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE stock_contract_leg_economics ADD CONSTRAINT stock_contract_leg_economics_version_positive CHECK (version > 0);","ALTER TABLE stock_contract_leg_economics ADD CONSTRAINT stock_contract_leg_economics_reserve_non_negative CHECK (reserve >= 0);","ALTER TABLE stock_contract_leg_economics ADD CONSTRAINT stock_contract_leg_economics_reserve_within_price CHECK (reserve <= purchase_price);","ALTER TABLE stock_contract_leg_economics ADD CONSTRAINT stock_contract_leg_economics_contract_leg_id_fk FOREIGN KEY (contract_leg_id) REFERENCES contract_leg(id);","CREATE TRIGGER stock_contract_leg_economics_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON stock_contract_leg_economics\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["contractLegId"]],"uniquenessConstraints":[["contractLegId","version"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A stock leg's revisable economics, one row per version — a revision appends, never mutates.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"stockQuantity","default":{"kind":"nothing"},"name":"stockQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Absolute amount, not a rate.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"StockContractLegEconomics","version":{"kind":"nothing"}}};

export const snStockContractLegEconomics: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"StockContractLegEconomics"};

export function texprStockContractLegEconomics(): ADL.ATypeExpr<StockContractLegEconomics> {
  return {value : {typeRef : {kind: "reference", value : snStockContractLegEconomics}, parameters : []}};
}

/**
 * Immutable identity of a `kind=invoice` leg (1:1 with ContractLeg), created at
 * trade-sale acceptance; economics live in [InvoiceContractLegEconomics]. The
 * backing invoice is reached through the purchase request, not linked directly.
 */
export interface InvoiceContractLeg {
  contractLegId: ContractLegId;
  /**
   * The purchase request this invoice contract leg relates to. Always set: the
   * leg is created at trade-sale acceptance, when the purchase request exists,
   * and unique: one invoice contract leg per trade sale.
   */
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeInvoiceContractLeg(
  input: {
    contractLegId: ContractLegId,
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): InvoiceContractLeg {
  return {
    contractLegId: input.contractLegId,
    purchaseRequestId: input.purchaseRequestId,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const InvoiceContractLeg_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE invoice_contract_leg ADD COLUMN kind text NOT NULL DEFAULT 'invoice' CHECK (kind = 'invoice');","ALTER TABLE invoice_contract_leg ADD CONSTRAINT invoice_contract_leg_contract_leg_id_kind_fk FOREIGN KEY (contract_leg_id, kind) REFERENCES contract_leg(id, kind);","CREATE TRIGGER invoice_contract_leg_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON invoice_contract_leg\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"uniquenessConstraints":[["contractLegId"],["purchaseRequestId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"Immutable identity of a `kind=invoice` leg (1:1 with ContractLeg), created at\ntrade-sale acceptance; economics live in [InvoiceContractLegEconomics]. The\nbacking invoice is reached through the purchase request, not linked directly.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[{"value":"The purchase request this invoice contract leg relates to. Always set: the\nleg is created at trade-sale acceptance, when the purchase request exists,\nand unique: one invoice contract leg per trade sale.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"InvoiceContractLeg","version":{"kind":"nothing"}}};

export const snInvoiceContractLeg: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"InvoiceContractLeg"};

export function texprInvoiceContractLeg(): ADL.ATypeExpr<InvoiceContractLeg> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceContractLeg}, parameters : []}};
}

/**
 * An invoice leg's revisable economics, one row per version — a revision appends,
 * never mutates (a post-acceptance amendment re-stamps by appending). Amounts are
 * absolute, stamped from the agreed sale. Open question: vat/duty might be
 * derivable from ledger positions instead of stamped here.
 */
export interface InvoiceContractLegEconomics {
  contractLegId: ContractLegId;
  version: number;
  /**
   * The complete amount the purchaser pays: net subtotal + duty + vat — not the bare subtotal.
   */
  purchasePrice: common.BigDecimal;
  /**
   * Absolute reserve held back until settlement — an amount, not a rate, for
   * the same reason as StockContractLeg.reserve.
   */
  reserve: common.BigDecimal;
  /**
   * VAT component of the purchaser's invoice — 0 when bonded/export.
   */
  vat: common.BigDecimal;
  /**
   * Duty component of the purchaser's invoice — 0 when bonded/export or already duty paid.
   */
  duty: common.BigDecimal;
  /**
   * The share of the fundable amount the nominated purchaser relationship funds as an
   * advance (1 = 1%) — the reserve is the subtotal's unfunded share of the same rate.
   */
  maxAdvancePct: common.BigDecimal;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeInvoiceContractLegEconomics(
  input: {
    contractLegId: ContractLegId,
    version: number,
    purchasePrice: common.BigDecimal,
    reserve: common.BigDecimal,
    vat: common.BigDecimal,
    duty: common.BigDecimal,
    maxAdvancePct: common.BigDecimal,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): InvoiceContractLegEconomics {
  return {
    contractLegId: input.contractLegId,
    version: input.version,
    purchasePrice: input.purchasePrice,
    reserve: input.reserve,
    vat: input.vat,
    duty: input.duty,
    maxAdvancePct: input.maxAdvancePct,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const InvoiceContractLegEconomics_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_version_positive CHECK (version > 0);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_reserve_non_negative CHECK (reserve >= 0);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_reserve_within_price CHECK (reserve <= purchase_price);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_vat_non_negative CHECK (vat >= 0);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_duty_non_negative CHECK (duty >= 0);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_max_advance_pct_range CHECK (max_advance_pct >= 0 AND max_advance_pct <= 100);","ALTER TABLE invoice_contract_leg_economics ADD CONSTRAINT invoice_contract_leg_economics_contract_leg_id_fk FOREIGN KEY (contract_leg_id) REFERENCES contract_leg(id);","CREATE TRIGGER invoice_contract_leg_economics_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON invoice_contract_leg_economics\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["contractLegId"]],"uniquenessConstraints":[["contractLegId","version"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"An invoice leg's revisable economics, one row per version — a revision appends,\nnever mutates (a post-acceptance amendment re-stamps by appending). Amounts are\nabsolute, stamped from the agreed sale. Open question: vat/duty might be\nderivable from ledger positions instead of stamped here.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[{"value":"The complete amount the purchaser pays: net subtotal + duty + vat — not the bare subtotal.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Absolute reserve held back until settlement — an amount, not a rate, for\nthe same reason as StockContractLeg.reserve.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"VAT component of the purchaser's invoice — 0 when bonded/export.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"vat","default":{"kind":"nothing"},"name":"vat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Duty component of the purchaser's invoice — 0 when bonded/export or already duty paid.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"duty","default":{"kind":"nothing"},"name":"duty","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"The share of the fundable amount the nominated purchaser relationship funds as an\nadvance (1 = 1%) — the reserve is the subtotal's unfunded share of the same rate.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"maxAdvancePct","default":{"kind":"nothing"},"name":"maxAdvancePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"InvoiceContractLegEconomics","version":{"kind":"nothing"}}};

export const snInvoiceContractLegEconomics: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"InvoiceContractLegEconomics"};

export function texprInvoiceContractLegEconomics(): ADL.ATypeExpr<InvoiceContractLegEconomics> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceContractLegEconomics}, parameters : []}};
}

export type AccruingFeeKind = 'monthly';
export const valuesAccruingFeeKind : AccruingFeeKind[] = ['monthly'];

const AccruingFeeKind_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Holding / financing fee accruing monthly on the outstanding balance\n(DealLeg monthly fee on the stock side, or the financing fee over an\ninvoice contract's waiting period). Room for daily / quarterly rhythms in\nfuture without churning the type.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"monthly","default":{"kind":"nothing"},"name":"monthly","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AccruingFeeKind","version":{"kind":"nothing"}}};

export const snAccruingFeeKind: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"AccruingFeeKind"};

export function texprAccruingFeeKind(): ADL.ATypeExpr<AccruingFeeKind> {
  return {value : {typeRef : {kind: "reference", value : snAccruingFeeKind}, parameters : []}};
}

/**
 * A fee that accrues against an outstanding balance over a period. With no `ratesCurveId`, `ratePct`
 * is the flat rate; with one, the fee follows that curve and `ratePct` is the spread on top (base +
 * reference). `compoundingMode` and the curve live here because only accruing fees compound or follow one.
 * AccruingFee stands alone: ContractTerms references it via accruingFeeId (no FK back here); the 1:1
 * cardinality is a UNIQUE constraint on contract_terms.accruing_fee_id.
 */
export interface AccruingFee {
  kind: AccruingFeeKind;
  ratePct: common.BigDecimal;
  ratesCurveId: (common_db.DbKey<ferovinum_app_db.RatesCurve>|null);
  compoundingMode: ferovinum_app_db.CompoundingMode;
  /**
   * When this fee becomes effective (starts accruing). The service requires it
   * to fall within the parent terms' effective window.
   */
  effectiveFrom: common.LocalDate;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeAccruingFee(
  input: {
    kind: AccruingFeeKind,
    ratePct: common.BigDecimal,
    ratesCurveId: (common_db.DbKey<ferovinum_app_db.RatesCurve>|null),
    compoundingMode?: ferovinum_app_db.CompoundingMode,
    effectiveFrom: common.LocalDate,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): AccruingFee {
  return {
    kind: input.kind,
    ratePct: input.ratePct,
    ratesCurveId: input.ratesCurveId,
    compoundingMode: input.compoundingMode === undefined ? "COMPOUNDING" : input.compoundingMode,
    effectiveFrom: input.effectiveFrom,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const AccruingFee_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE accruing_fee ADD CONSTRAINT accruing_fee_rate_pct_range CHECK (rate_pct BETWEEN 0 AND 100);","CREATE TRIGGER accruing_fee_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON accruing_fee\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A fee that accrues against an outstanding balance over a period. With no `ratesCurveId`, `ratePct`\nis the flat rate; with one, the fee follows that curve and `ratePct` is the spread on top (base +\nreference). `compoundingMode` and the curve live here because only accruing fees compound or follow one.\n\nAccruingFee stands alone: ContractTerms references it via accruingFeeId (no FK back here); the 1:1\ncardinality is a UNIQUE constraint on contract_terms.accruing_fee_id.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFeeKind"}},"parameters":[]}},{"annotations":[],"serializedName":"ratePct","default":{"kind":"nothing"},"name":"ratePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"ratesCurveId","default":{"kind":"nothing"},"name":"ratesCurveId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"RatesCurve"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"compoundingMode","default":{"kind":"just","value":"COMPOUNDING"},"name":"compoundingMode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CompoundingMode"}},"parameters":[]}},{"annotations":[{"value":"When this fee becomes effective (starts accruing). The service requires it\nto fall within the parent terms' effective window.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"effectiveFrom","default":{"kind":"nothing"},"name":"effectiveFrom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"AccruingFee","version":{"kind":"nothing"}}};

export const snAccruingFee: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"AccruingFee"};

export function texprAccruingFee(): ADL.ATypeExpr<AccruingFee> {
  return {value : {typeRef : {kind: "reference", value : snAccruingFee}, parameters : []}};
}

export type AccruingFeeId = common_db.DbKey<AccruingFee>;

const AccruingFeeId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFee"}},"parameters":[]}]}}},"name":"AccruingFeeId","version":{"kind":"nothing"}}};

export const snAccruingFeeId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"AccruingFeeId"};

export function texprAccruingFeeId(): ADL.ATypeExpr<AccruingFeeId> {
  return {value : {typeRef : {kind: "reference", value : snAccruingFeeId}, parameters : []}};
}

export type ChargedFeeType = 'event' | 'monthlyCapital';
export const valuesChargedFeeType : ChargedFeeType[] = ['event', 'monthlyCapital'];

const ChargedFeeType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"What kind of fee a [ChargedFee] row records.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"A discrete event fee (throughput / capex). Many can fall on the same date for a contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"event","default":{"kind":"nothing"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"The monthly capital (holding/financing) fee. At most one per contract per period.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"monthlyCapital","default":{"kind":"nothing"},"name":"monthlyCapital","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ChargedFeeType","version":{"kind":"nothing"}}};

export const snChargedFeeType: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ChargedFeeType"};

export function texprChargedFeeType(): ADL.ATypeExpr<ChargedFeeType> {
  return {value : {typeRef : {kind: "reference", value : snChargedFeeType}, parameters : []}};
}

/**
 * The durable record of one fee charge against a leg — what was billed (`rate`/`chargeableBalance`/
 * `amount`, in `asset`) and its ledger journal. `(contractLegId, periodStart, journalRef)` is unique
 * for `monthlyCapital`: guards the double-charge race (racing sweeps mint the same ref) while a
 * re-price/void journal adds its signed adjustment row. Event fees have no such constraint.
 */
export interface ChargedFee {
  contractLegId: ContractLegId;
  feeType: ChargedFeeType;
  periodStart: common.LocalDate;
  rate: common.BigDecimal;
  chargeableBalance: common.BigDecimal;
  amount: common.BigDecimal;
  asset: string;
  journalRef: string;
  createdAt: common.Instant;
}

export function makeChargedFee(
  input: {
    contractLegId: ContractLegId,
    feeType: ChargedFeeType,
    periodStart: common.LocalDate,
    rate: common.BigDecimal,
    chargeableBalance: common.BigDecimal,
    amount: common.BigDecimal,
    asset: string,
    journalRef: string,
    createdAt?: common.Instant,
  }
): ChargedFee {
  return {
    contractLegId: input.contractLegId,
    feeType: input.feeType,
    periodStart: input.periodStart,
    rate: input.rate,
    chargeableBalance: input.chargeableBalance,
    amount: input.amount,
    asset: input.asset,
    journalRef: input.journalRef,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
  };
}

const ChargedFee_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["CREATE UNIQUE INDEX charged_fee_monthly_capital_uq ON charged_fee (contract_leg_id, period_start, journal_ref) WHERE fee_type = 'monthlyCapital';"],"withIdPrimaryKey":true,"indexes":[["contractLegId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"The durable record of one fee charge against a leg — what was billed (`rate`/`chargeableBalance`/\n`amount`, in `asset`) and its ledger journal. `(contractLegId, periodStart, journalRef)` is unique\nfor `monthlyCapital`: guards the double-charge race (racing sweeps mint the same ref) while a\nre-price/void journal adds its signed adjustment row. Event fees have no such constraint.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"feeType","default":{"kind":"nothing"},"name":"feeType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ChargedFeeType"}},"parameters":[]}},{"annotations":[],"serializedName":"periodStart","default":{"kind":"nothing"},"name":"periodStart","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"rate","default":{"kind":"nothing"},"name":"rate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"chargeableBalance","default":{"kind":"nothing"},"name":"chargeableBalance","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"asset","default":{"kind":"nothing"},"name":"asset","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"journalRef","default":{"kind":"nothing"},"name":"journalRef","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ChargedFee","version":{"kind":"nothing"}}};

export const snChargedFee: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ChargedFee"};

export function texprChargedFee(): ADL.ATypeExpr<ChargedFee> {
  return {value : {typeRef : {kind: "reference", value : snChargedFee}, parameters : []}};
}

export type ChargedFeeId = common_db.DbKey<ChargedFee>;

const ChargedFeeId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ChargedFee"}},"parameters":[]}]}}},"name":"ChargedFeeId","version":{"kind":"nothing"}}};

export const snChargedFeeId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ChargedFeeId"};

export function texprChargedFeeId(): ADL.ATypeExpr<ChargedFeeId> {
  return {value : {typeRef : {kind: "reference", value : snChargedFeeId}, parameters : []}};
}

/**
 * A versioned set of commercial terms for a contract leg. `version` starts at 1
 * and increments by 1 each time the terms are revised; the highest version is
 * the current one. The `version` is assigned by the system, never by the caller.
 * Each terms version points to exactly one AccruingFee (the holding/financing
 * rate that applies under these terms). Event fees and completion milestones
 * hang off the terms row separately, since there can be many of each.
 */
export interface ContractTerms {
  contractLegId: ContractLegId;
  version: number;
  effectiveFrom: common.LocalDate;
  effectiveUntil: common.LocalDate;
  accruingFeeId: AccruingFeeId;
  /**
   * Free-text note about this terms version (what changed, why). Optional;
   * defaults to "" so callers and old rows don't need to supply anything.
   */
  description: string;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeContractTerms(
  input: {
    contractLegId: ContractLegId,
    version: number,
    effectiveFrom: common.LocalDate,
    effectiveUntil: common.LocalDate,
    accruingFeeId: AccruingFeeId,
    description?: string,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): ContractTerms {
  return {
    contractLegId: input.contractLegId,
    version: input.version,
    effectiveFrom: input.effectiveFrom,
    effectiveUntil: input.effectiveUntil,
    accruingFeeId: input.accruingFeeId,
    description: input.description === undefined ? "" : input.description,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const ContractTerms_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE contract_terms ADD CONSTRAINT contract_terms_version_positive CHECK (version > 0);","ALTER TABLE contract_terms ADD CONSTRAINT contract_terms_window_ordered CHECK (effective_until >= effective_from);","CREATE TRIGGER contract_terms_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON contract_terms\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["contractLegId"]],"uniquenessConstraints":[["contractLegId","version"],["accruingFeeId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A versioned set of commercial terms for a contract leg. `version` starts at 1\nand increments by 1 each time the terms are revised; the highest version is\nthe current one. The `version` is assigned by the system, never by the caller.\n\nEach terms version points to exactly one AccruingFee (the holding/financing\nrate that applies under these terms). Event fees and completion milestones\nhang off the terms row separately, since there can be many of each.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[],"serializedName":"effectiveFrom","default":{"kind":"nothing"},"name":"effectiveFrom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"effectiveUntil","default":{"kind":"nothing"},"name":"effectiveUntil","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"accruingFeeId","default":{"kind":"nothing"},"name":"accruingFeeId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFeeId"}},"parameters":[]}},{"annotations":[{"value":"Free-text note about this terms version (what changed, why). Optional;\ndefaults to \"\" so callers and old rows don't need to supply anything.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"description","default":{"kind":"just","value":""},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ContractTerms","version":{"kind":"nothing"}}};

export const snContractTerms: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractTerms"};

export function texprContractTerms(): ADL.ATypeExpr<ContractTerms> {
  return {value : {typeRef : {kind: "reference", value : snContractTerms}, parameters : []}};
}

export type ContractTermsId = common_db.DbKey<ContractTerms>;

const ContractTermsId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTerms"}},"parameters":[]}]}}},"name":"ContractTermsId","version":{"kind":"nothing"}}};

export const snContractTermsId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractTermsId"};

export function texprContractTermsId(): ADL.ATypeExpr<ContractTermsId> {
  return {value : {typeRef : {kind: "reference", value : snContractTermsId}, parameters : []}};
}

export type EventFeeKind = 'throughput' | 'capex';
export const valuesEventFeeKind : EventFeeKind[] = ['throughput', 'capex'];

const EventFeeKind_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Charged per throughput event. On the stock side this is the throughput fee\non a sale; on the invoice side it is the per-purchase-request (nominated\npurchaser) fee, which is the same throughput concept.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"throughput","default":{"kind":"nothing"},"name":"throughput","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"Charged per capex addition on top of the capitalised expense amount.\nCharged by default; certain capex categories may be exempt at billing time.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"capex","default":{"kind":"nothing"},"name":"capex","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"EventFeeKind","version":{"kind":"nothing"}}};

export const snEventFeeKind: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EventFeeKind"};

export function texprEventFeeKind(): ADL.ATypeExpr<EventFeeKind> {
  return {value : {typeRef : {kind: "reference", value : snEventFeeKind}, parameters : []}};
}

/**
 * A flat-rate fee charged per discrete event (a sale, a capex addition). No
 * curve, no compounding — it's a one-off percentage on an event amount.
 */
export interface EventFee {
  contractTermsId: ContractTermsId;
  kind: EventFeeKind;
  ratePct: common.BigDecimal;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeEventFee(
  input: {
    contractTermsId: ContractTermsId,
    kind: EventFeeKind,
    ratePct: common.BigDecimal,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): EventFee {
  return {
    contractTermsId: input.contractTermsId,
    kind: input.kind,
    ratePct: input.ratePct,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const EventFee_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE event_fee ADD CONSTRAINT event_fee_rate_pct_range CHECK (rate_pct BETWEEN 0 AND 100);","CREATE TRIGGER event_fee_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON event_fee\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"uniquenessConstraints":[["contractTermsId","kind"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A flat-rate fee charged per discrete event (a sale, a capex addition). No\ncurve, no compounding — it's a one-off percentage on an event amount.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractTermsId","default":{"kind":"nothing"},"name":"contractTermsId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsId"}},"parameters":[]}},{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"EventFeeKind"}},"parameters":[]}},{"annotations":[],"serializedName":"ratePct","default":{"kind":"nothing"},"name":"ratePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"EventFee","version":{"kind":"nothing"}}};

export const snEventFee: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EventFee"};

export function texprEventFee(): ADL.ATypeExpr<EventFee> {
  return {value : {typeRef : {kind: "reference", value : snEventFee}, parameters : []}};
}

export type EventFeeId = common_db.DbKey<EventFee>;

const EventFeeId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"EventFee"}},"parameters":[]}]}}},"name":"EventFeeId","version":{"kind":"nothing"}}};

export const snEventFeeId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EventFeeId"};

export function texprEventFeeId(): ADL.ATypeExpr<EventFeeId> {
  return {value : {typeRef : {kind: "reference", value : snEventFeeId}, parameters : []}};
}

/**
 * A point on the contract's completion schedule: by `byDate` a cumulative
 * `cumulativeAmount` of the contract should be completed.
 */
export interface CompletionMilestone {
  contractTermsId: ContractTermsId;
  byDate: common.LocalDate;
  cumulativeAmount: common.BigDecimal;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeCompletionMilestone(
  input: {
    contractTermsId: ContractTermsId,
    byDate: common.LocalDate,
    cumulativeAmount: common.BigDecimal,
    createdAt?: common.Instant,
    updatedAt?: common.Instant,
  }
): CompletionMilestone {
  return {
    contractTermsId: input.contractTermsId,
    byDate: input.byDate,
    cumulativeAmount: input.cumulativeAmount,
    createdAt: input.createdAt === undefined ? 0 : input.createdAt,
    updatedAt: input.updatedAt === undefined ? 0 : input.updatedAt,
  };
}

const CompletionMilestone_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":{"extraSql":["ALTER TABLE completion_milestone ADD CONSTRAINT completion_milestone_cumulative_amount_non_negative CHECK (cumulative_amount >= 0);","CREATE TRIGGER completion_milestone_set_create_update_timestamps\n    BEFORE INSERT OR UPDATE ON completion_milestone\n    FOR EACH ROW\n    EXECUTE FUNCTION set_create_update_timestamps();"],"withIdPrimaryKey":true,"indexes":[["contractTermsId"]]},"key":{"moduleName":"common.db","name":"DbTable"}},{"value":"A point on the contract's completion schedule: by `byDate` a cumulative\n`cumulativeAmount` of the contract should be completed.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractTermsId","default":{"kind":"nothing"},"name":"contractTermsId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsId"}},"parameters":[]}},{"annotations":[],"serializedName":"byDate","default":{"kind":"nothing"},"name":"byDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"cumulativeAmount","default":{"kind":"nothing"},"name":"cumulativeAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"just","value":0},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"just","value":0},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"CompletionMilestone","version":{"kind":"nothing"}}};

export const snCompletionMilestone: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CompletionMilestone"};

export function texprCompletionMilestone(): ADL.ATypeExpr<CompletionMilestone> {
  return {value : {typeRef : {kind: "reference", value : snCompletionMilestone}, parameters : []}};
}

export type CompletionMilestoneId = common_db.DbKey<CompletionMilestone>;

const CompletionMilestoneId_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CompletionMilestone"}},"parameters":[]}]}}},"name":"CompletionMilestoneId","version":{"kind":"nothing"}}};

export const snCompletionMilestoneId: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CompletionMilestoneId"};

export function texprCompletionMilestoneId(): ADL.ATypeExpr<CompletionMilestoneId> {
  return {value : {typeRef : {kind: "reference", value : snCompletionMilestoneId}, parameters : []}};
}

export interface AccruingFeeDef {
  kind: AccruingFeeKind;
  ratePct: common.BigDecimal;
  ratesCurveId: (common_db.DbKey<ferovinum_app_db.RatesCurve>|null);
  compoundingMode: ferovinum_app_db.CompoundingMode;
  /**
   * When the fee starts accruing; must fall within the terms' effective window.
   */
  effectiveFrom: common.LocalDate;
}

export function makeAccruingFeeDef(
  input: {
    kind: AccruingFeeKind,
    ratePct: common.BigDecimal,
    ratesCurveId: (common_db.DbKey<ferovinum_app_db.RatesCurve>|null),
    compoundingMode?: ferovinum_app_db.CompoundingMode,
    effectiveFrom: common.LocalDate,
  }
): AccruingFeeDef {
  return {
    kind: input.kind,
    ratePct: input.ratePct,
    ratesCurveId: input.ratesCurveId,
    compoundingMode: input.compoundingMode === undefined ? "COMPOUNDING" : input.compoundingMode,
    effectiveFrom: input.effectiveFrom,
  };
}

const AccruingFeeDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFeeKind"}},"parameters":[]}},{"annotations":[],"serializedName":"ratePct","default":{"kind":"nothing"},"name":"ratePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"ratesCurveId","default":{"kind":"nothing"},"name":"ratesCurveId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"RatesCurve"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"compoundingMode","default":{"kind":"just","value":"COMPOUNDING"},"name":"compoundingMode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CompoundingMode"}},"parameters":[]}},{"annotations":[{"value":"When the fee starts accruing; must fall within the terms' effective window.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"effectiveFrom","default":{"kind":"nothing"},"name":"effectiveFrom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"AccruingFeeDef","version":{"kind":"nothing"}}};

export const snAccruingFeeDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"AccruingFeeDef"};

export function texprAccruingFeeDef(): ADL.ATypeExpr<AccruingFeeDef> {
  return {value : {typeRef : {kind: "reference", value : snAccruingFeeDef}, parameters : []}};
}

export interface EventFeeDef {
  kind: EventFeeKind;
  ratePct: common.BigDecimal;
}

export function makeEventFeeDef(
  input: {
    kind: EventFeeKind,
    ratePct: common.BigDecimal,
  }
): EventFeeDef {
  return {
    kind: input.kind,
    ratePct: input.ratePct,
  };
}

const EventFeeDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"EventFeeKind"}},"parameters":[]}},{"annotations":[],"serializedName":"ratePct","default":{"kind":"nothing"},"name":"ratePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"EventFeeDef","version":{"kind":"nothing"}}};

export const snEventFeeDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EventFeeDef"};

export function texprEventFeeDef(): ADL.ATypeExpr<EventFeeDef> {
  return {value : {typeRef : {kind: "reference", value : snEventFeeDef}, parameters : []}};
}

export interface CompletionMilestoneDef {
  byDate: common.LocalDate;
  cumulativeAmount: common.BigDecimal;
}

export function makeCompletionMilestoneDef(
  input: {
    byDate: common.LocalDate,
    cumulativeAmount: common.BigDecimal,
  }
): CompletionMilestoneDef {
  return {
    byDate: input.byDate,
    cumulativeAmount: input.cumulativeAmount,
  };
}

const CompletionMilestoneDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"byDate","default":{"kind":"nothing"},"name":"byDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"cumulativeAmount","default":{"kind":"nothing"},"name":"cumulativeAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"CompletionMilestoneDef","version":{"kind":"nothing"}}};

export const snCompletionMilestoneDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CompletionMilestoneDef"};

export function texprCompletionMilestoneDef(): ADL.ATypeExpr<CompletionMilestoneDef> {
  return {value : {typeRef : {kind: "reference", value : snCompletionMilestoneDef}, parameters : []}};
}

export interface ContractTermsDef {
  effectiveFrom: common.LocalDate;
  effectiveUntil: common.LocalDate;
  /**
   * Exactly one accruing fee per terms version (1:1 with ContractTerms).
   */
  accruingFee: AccruingFeeDef;
  eventFees: EventFeeDef[];
  completionMilestones: CompletionMilestoneDef[];
  /**
   * Optional free-text note (see ContractTerms.description).
   */
  description: string;
}

export function makeContractTermsDef(
  input: {
    effectiveFrom: common.LocalDate,
    effectiveUntil: common.LocalDate,
    accruingFee: AccruingFeeDef,
    eventFees: EventFeeDef[],
    completionMilestones: CompletionMilestoneDef[],
    description?: string,
  }
): ContractTermsDef {
  return {
    effectiveFrom: input.effectiveFrom,
    effectiveUntil: input.effectiveUntil,
    accruingFee: input.accruingFee,
    eventFees: input.eventFees,
    completionMilestones: input.completionMilestones,
    description: input.description === undefined ? "" : input.description,
  };
}

const ContractTermsDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"effectiveFrom","default":{"kind":"nothing"},"name":"effectiveFrom","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"effectiveUntil","default":{"kind":"nothing"},"name":"effectiveUntil","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"Exactly one accruing fee per terms version (1:1 with ContractTerms).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"accruingFee","default":{"kind":"nothing"},"name":"accruingFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFeeDef"}},"parameters":[]}},{"annotations":[],"serializedName":"eventFees","default":{"kind":"nothing"},"name":"eventFees","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"EventFeeDef"}},"parameters":[]}]}},{"annotations":[],"serializedName":"completionMilestones","default":{"kind":"nothing"},"name":"completionMilestones","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CompletionMilestoneDef"}},"parameters":[]}]}},{"annotations":[{"value":"Optional free-text note (see ContractTerms.description).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"description","default":{"kind":"just","value":""},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ContractTermsDef","version":{"kind":"nothing"}}};

export const snContractTermsDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractTermsDef"};

export function texprContractTermsDef(): ADL.ATypeExpr<ContractTermsDef> {
  return {value : {typeRef : {kind: "reference", value : snContractTermsDef}, parameters : []}};
}

export interface StockContractLegDef {
  productId: ferovinum_app_db.ProductId;
  dealLegId: (ferovinum_app_db.DealLegId|null);
  purchasePrice: common.BigDecimal;
  stockQuantity: common.BigDecimal;
  reserve: common.BigDecimal;
}

export function makeStockContractLegDef(
  input: {
    productId: ferovinum_app_db.ProductId,
    dealLegId: (ferovinum_app_db.DealLegId|null),
    purchasePrice: common.BigDecimal,
    stockQuantity: common.BigDecimal,
    reserve: common.BigDecimal,
  }
): StockContractLegDef {
  return {
    productId: input.productId,
    dealLegId: input.dealLegId,
    purchasePrice: input.purchasePrice,
    stockQuantity: input.stockQuantity,
    reserve: input.reserve,
  };
}

const StockContractLegDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"stockQuantity","default":{"kind":"nothing"},"name":"stockQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"StockContractLegDef","version":{"kind":"nothing"}}};

export const snStockContractLegDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"StockContractLegDef"};

export function texprStockContractLegDef(): ADL.ATypeExpr<StockContractLegDef> {
  return {value : {typeRef : {kind: "reference", value : snStockContractLegDef}, parameters : []}};
}

export interface StockContractLegEconomicsDef {
  purchasePrice: common.BigDecimal;
  stockQuantity: common.BigDecimal;
  reserve: common.BigDecimal;
}

export function makeStockContractLegEconomicsDef(
  input: {
    purchasePrice: common.BigDecimal,
    stockQuantity: common.BigDecimal,
    reserve: common.BigDecimal,
  }
): StockContractLegEconomicsDef {
  return {
    purchasePrice: input.purchasePrice,
    stockQuantity: input.stockQuantity,
    reserve: input.reserve,
  };
}

const StockContractLegEconomicsDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"stockQuantity","default":{"kind":"nothing"},"name":"stockQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"StockContractLegEconomicsDef","version":{"kind":"nothing"}}};

export const snStockContractLegEconomicsDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"StockContractLegEconomicsDef"};

export function texprStockContractLegEconomicsDef(): ADL.ATypeExpr<StockContractLegEconomicsDef> {
  return {value : {typeRef : {kind: "reference", value : snStockContractLegEconomicsDef}, parameters : []}};
}

export interface InvoiceContractLegDef {
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  /**
   * The complete purchaser-payable amount (see InvoiceContractLegEconomics.purchasePrice).
   */
  purchasePrice: common.BigDecimal;
  /**
   * Absolute reserve amount (see InvoiceContractLegEconomics.reserve).
   */
  reserve: common.BigDecimal;
  /**
   * VAT component of the purchaser's invoice — 0 when bonded/export.
   */
  vat: common.BigDecimal;
  /**
   * Duty component of the purchaser's invoice.
   */
  duty: common.BigDecimal;
  /**
   * Max advance rate at stamping (see InvoiceContractLegEconomics.maxAdvancePct).
   */
  maxAdvancePct: common.BigDecimal;
}

export function makeInvoiceContractLegDef(
  input: {
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    purchasePrice: common.BigDecimal,
    reserve: common.BigDecimal,
    vat: common.BigDecimal,
    duty: common.BigDecimal,
    maxAdvancePct: common.BigDecimal,
  }
): InvoiceContractLegDef {
  return {
    purchaseRequestId: input.purchaseRequestId,
    purchasePrice: input.purchasePrice,
    reserve: input.reserve,
    vat: input.vat,
    duty: input.duty,
    maxAdvancePct: input.maxAdvancePct,
  };
}

const InvoiceContractLegDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[{"value":"The complete purchaser-payable amount (see InvoiceContractLegEconomics.purchasePrice).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Absolute reserve amount (see InvoiceContractLegEconomics.reserve).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"VAT component of the purchaser's invoice — 0 when bonded/export.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"vat","default":{"kind":"nothing"},"name":"vat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Duty component of the purchaser's invoice.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"duty","default":{"kind":"nothing"},"name":"duty","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Max advance rate at stamping (see InvoiceContractLegEconomics.maxAdvancePct).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"maxAdvancePct","default":{"kind":"nothing"},"name":"maxAdvancePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"InvoiceContractLegDef","version":{"kind":"nothing"}}};

export const snInvoiceContractLegDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"InvoiceContractLegDef"};

export function texprInvoiceContractLegDef(): ADL.ATypeExpr<InvoiceContractLegDef> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceContractLegDef}, parameters : []}};
}

/**
 * A new version of an invoice leg's economics (see InvoiceContractLegEconomics).
 */
export interface InvoiceContractLegEconomicsDef {
  purchasePrice: common.BigDecimal;
  reserve: common.BigDecimal;
  vat: common.BigDecimal;
  duty: common.BigDecimal;
  maxAdvancePct: common.BigDecimal;
}

export function makeInvoiceContractLegEconomicsDef(
  input: {
    purchasePrice: common.BigDecimal,
    reserve: common.BigDecimal,
    vat: common.BigDecimal,
    duty: common.BigDecimal,
    maxAdvancePct: common.BigDecimal,
  }
): InvoiceContractLegEconomicsDef {
  return {
    purchasePrice: input.purchasePrice,
    reserve: input.reserve,
    vat: input.vat,
    duty: input.duty,
    maxAdvancePct: input.maxAdvancePct,
  };
}

const InvoiceContractLegEconomicsDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"A new version of an invoice leg's economics (see InvoiceContractLegEconomics).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"reserve","default":{"kind":"nothing"},"name":"reserve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"vat","default":{"kind":"nothing"},"name":"vat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"duty","default":{"kind":"nothing"},"name":"duty","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"maxAdvancePct","default":{"kind":"nothing"},"name":"maxAdvancePct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"InvoiceContractLegEconomicsDef","version":{"kind":"nothing"}}};

export const snInvoiceContractLegEconomicsDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"InvoiceContractLegEconomicsDef"};

export function texprInvoiceContractLegEconomicsDef(): ADL.ATypeExpr<InvoiceContractLegEconomicsDef> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceContractLegEconomicsDef}, parameters : []}};
}

export interface ContractSubtypeDef_Stock {
  kind: 'stock';
  value: StockContractLegDef;
}
export interface ContractSubtypeDef_Invoice {
  kind: 'invoice';
  value: InvoiceContractLegDef;
}

/**
 * The subtype-specific definition; also fixes the leg's `kind`.
 */
export type ContractSubtypeDef = ContractSubtypeDef_Stock | ContractSubtypeDef_Invoice;

export interface ContractSubtypeDefOpts {
  stock: StockContractLegDef;
  invoice: InvoiceContractLegDef;
}

export function makeContractSubtypeDef<K extends keyof ContractSubtypeDefOpts>(kind: K, value: ContractSubtypeDefOpts[K]) { return {kind, value}; }

const ContractSubtypeDef_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"The subtype-specific definition; also fixes the leg's `kind`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock","default":{"kind":"nothing"},"name":"stock","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"StockContractLegDef"}},"parameters":[]}},{"annotations":[],"serializedName":"invoice","default":{"kind":"nothing"},"name":"invoice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"InvoiceContractLegDef"}},"parameters":[]}}]}},"name":"ContractSubtypeDef","version":{"kind":"nothing"}}};

export const snContractSubtypeDef: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractSubtypeDef"};

export function texprContractSubtypeDef(): ADL.ATypeExpr<ContractSubtypeDef> {
  return {value : {typeRef : {kind: "reference", value : snContractSubtypeDef}, parameters : []}};
}

export interface CreateContractLegReq {
  feroEntity: ferovinum_app_db.FeroEntity;
  counterpartyId: ferovinum_app_db.OrganisationId;
  /**
   * The master agreement version in force, snapshotted onto the leg.
   */
  mtaVersion: ferovinum_app_db.MasterAgreementVersion;
  subtype: ContractSubtypeDef;
  /**
   * The initial terms (version 1).
   */
  terms: ContractTermsDef;
}

export function makeCreateContractLegReq(
  input: {
    feroEntity: ferovinum_app_db.FeroEntity,
    counterpartyId: ferovinum_app_db.OrganisationId,
    mtaVersion: ferovinum_app_db.MasterAgreementVersion,
    subtype: ContractSubtypeDef,
    terms: ContractTermsDef,
  }
): CreateContractLegReq {
  return {
    feroEntity: input.feroEntity,
    counterpartyId: input.counterpartyId,
    mtaVersion: input.mtaVersion,
    subtype: input.subtype,
    terms: input.terms,
  };
}

const CreateContractLegReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"counterpartyId","default":{"kind":"nothing"},"name":"counterpartyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[{"value":"The master agreement version in force, snapshotted onto the leg.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"mtaVersion","default":{"kind":"nothing"},"name":"mtaVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MasterAgreementVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"subtype","default":{"kind":"nothing"},"name":"subtype","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractSubtypeDef"}},"parameters":[]}},{"annotations":[{"value":"The initial terms (version 1).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"terms","default":{"kind":"nothing"},"name":"terms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsDef"}},"parameters":[]}}]}},"name":"CreateContractLegReq","version":{"kind":"nothing"}}};

export const snCreateContractLegReq: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CreateContractLegReq"};

export function texprCreateContractLegReq(): ADL.ATypeExpr<CreateContractLegReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateContractLegReq}, parameters : []}};
}

export interface CreateContractLegResp {
  contractLegId: ContractLegId;
}

export function makeCreateContractLegResp(
  input: {
    contractLegId: ContractLegId,
  }
): CreateContractLegResp {
  return {
    contractLegId: input.contractLegId,
  };
}

const CreateContractLegResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}}]}},"name":"CreateContractLegResp","version":{"kind":"nothing"}}};

export const snCreateContractLegResp: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CreateContractLegResp"};

export function texprCreateContractLegResp(): ADL.ATypeExpr<CreateContractLegResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateContractLegResp}, parameters : []}};
}

/**
 * Append a new version of terms to an existing contract leg.
 */
export interface ReviseContractTermsReq {
  contractLegId: ContractLegId;
  terms: ContractTermsDef;
}

export function makeReviseContractTermsReq(
  input: {
    contractLegId: ContractLegId,
    terms: ContractTermsDef,
  }
): ReviseContractTermsReq {
  return {
    contractLegId: input.contractLegId,
    terms: input.terms,
  };
}

const ReviseContractTermsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"Append a new version of terms to an existing contract leg.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"terms","default":{"kind":"nothing"},"name":"terms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsDef"}},"parameters":[]}}]}},"name":"ReviseContractTermsReq","version":{"kind":"nothing"}}};

export const snReviseContractTermsReq: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ReviseContractTermsReq"};

export function texprReviseContractTermsReq(): ADL.ATypeExpr<ReviseContractTermsReq> {
  return {value : {typeRef : {kind: "reference", value : snReviseContractTermsReq}, parameters : []}};
}

export interface ReviseContractTermsResp {
  contractTermsId: ContractTermsId;
  /**
   * The version assigned to the newly created terms.
   */
  version: number;
}

export function makeReviseContractTermsResp(
  input: {
    contractTermsId: ContractTermsId,
    version: number,
  }
): ReviseContractTermsResp {
  return {
    contractTermsId: input.contractTermsId,
    version: input.version,
  };
}

const ReviseContractTermsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractTermsId","default":{"kind":"nothing"},"name":"contractTermsId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsId"}},"parameters":[]}},{"annotations":[{"value":"The version assigned to the newly created terms.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}}]}},"name":"ReviseContractTermsResp","version":{"kind":"nothing"}}};

export const snReviseContractTermsResp: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ReviseContractTermsResp"};

export function texprReviseContractTermsResp(): ADL.ATypeExpr<ReviseContractTermsResp> {
  return {value : {typeRef : {kind: "reference", value : snReviseContractTermsResp}, parameters : []}};
}

export interface ContractTermsView {
  contractTerms: common_db.WithDbId<ContractTerms>;
  accruingFee: common_db.WithDbId<AccruingFee>;
  eventFees: common_db.WithDbId<EventFee>[];
  completionMilestones: common_db.WithDbId<CompletionMilestone>[];
}

export function makeContractTermsView(
  input: {
    contractTerms: common_db.WithDbId<ContractTerms>,
    accruingFee: common_db.WithDbId<AccruingFee>,
    eventFees: common_db.WithDbId<EventFee>[],
    completionMilestones: common_db.WithDbId<CompletionMilestone>[],
  }
): ContractTermsView {
  return {
    contractTerms: input.contractTerms,
    accruingFee: input.accruingFee,
    eventFees: input.eventFees,
    completionMilestones: input.completionMilestones,
  };
}

const ContractTermsView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractTerms","default":{"kind":"nothing"},"name":"contractTerms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTerms"}},"parameters":[]}]}},{"annotations":[],"serializedName":"accruingFee","default":{"kind":"nothing"},"name":"accruingFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"AccruingFee"}},"parameters":[]}]}},{"annotations":[],"serializedName":"eventFees","default":{"kind":"nothing"},"name":"eventFees","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"EventFee"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"completionMilestones","default":{"kind":"nothing"},"name":"completionMilestones","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CompletionMilestone"}},"parameters":[]}]}]}}]}},"name":"ContractTermsView","version":{"kind":"nothing"}}};

export const snContractTermsView: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractTermsView"};

export function texprContractTermsView(): ADL.ATypeExpr<ContractTermsView> {
  return {value : {typeRef : {kind: "reference", value : snContractTermsView}, parameters : []}};
}

export interface StockContractLegView {
  leg: StockContractLeg;
  economics: StockContractLegEconomics;
}

export function makeStockContractLegView(
  input: {
    leg: StockContractLeg,
    economics: StockContractLegEconomics,
  }
): StockContractLegView {
  return {
    leg: input.leg,
    economics: input.economics,
  };
}

const StockContractLegView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"leg","default":{"kind":"nothing"},"name":"leg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"StockContractLeg"}},"parameters":[]}},{"annotations":[],"serializedName":"economics","default":{"kind":"nothing"},"name":"economics","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"StockContractLegEconomics"}},"parameters":[]}}]}},"name":"StockContractLegView","version":{"kind":"nothing"}}};

export const snStockContractLegView: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"StockContractLegView"};

export function texprStockContractLegView(): ADL.ATypeExpr<StockContractLegView> {
  return {value : {typeRef : {kind: "reference", value : snStockContractLegView}, parameters : []}};
}

export interface InvoiceContractLegView {
  leg: InvoiceContractLeg;
  /**
   * The current (highest-version) economics — the ones in force.
   */
  economics: InvoiceContractLegEconomics;
}

export function makeInvoiceContractLegView(
  input: {
    leg: InvoiceContractLeg,
    economics: InvoiceContractLegEconomics,
  }
): InvoiceContractLegView {
  return {
    leg: input.leg,
    economics: input.economics,
  };
}

const InvoiceContractLegView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"leg","default":{"kind":"nothing"},"name":"leg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"InvoiceContractLeg"}},"parameters":[]}},{"annotations":[{"value":"The current (highest-version) economics — the ones in force.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"economics","default":{"kind":"nothing"},"name":"economics","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"InvoiceContractLegEconomics"}},"parameters":[]}}]}},"name":"InvoiceContractLegView","version":{"kind":"nothing"}}};

export const snInvoiceContractLegView: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"InvoiceContractLegView"};

export function texprInvoiceContractLegView(): ADL.ATypeExpr<InvoiceContractLegView> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceContractLegView}, parameters : []}};
}

export interface ContractSubtypeView_Stock {
  kind: 'stock';
  value: StockContractLegView;
}
export interface ContractSubtypeView_Invoice {
  kind: 'invoice';
  value: InvoiceContractLegView;
}

export type ContractSubtypeView = ContractSubtypeView_Stock | ContractSubtypeView_Invoice;

export interface ContractSubtypeViewOpts {
  stock: StockContractLegView;
  invoice: InvoiceContractLegView;
}

export function makeContractSubtypeView<K extends keyof ContractSubtypeViewOpts>(kind: K, value: ContractSubtypeViewOpts[K]) { return {kind, value}; }

const ContractSubtypeView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock","default":{"kind":"nothing"},"name":"stock","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"StockContractLegView"}},"parameters":[]}},{"annotations":[],"serializedName":"invoice","default":{"kind":"nothing"},"name":"invoice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"InvoiceContractLegView"}},"parameters":[]}}]}},"name":"ContractSubtypeView","version":{"kind":"nothing"}}};

export const snContractSubtypeView: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractSubtypeView"};

export function texprContractSubtypeView(): ADL.ATypeExpr<ContractSubtypeView> {
  return {value : {typeRef : {kind: "reference", value : snContractSubtypeView}, parameters : []}};
}

export interface ContractLegView {
  contractLeg: common_db.WithDbId<ContractLeg>;
  subtype: ContractSubtypeView;
  terms: ContractTermsView[];
  /**
   * The leg's current lifecycle status — the latest contract_leg_status row, or ACTIVE if none.
   */
  status: ContractStatus;
}

export function makeContractLegView(
  input: {
    contractLeg: common_db.WithDbId<ContractLeg>,
    subtype: ContractSubtypeView,
    terms: ContractTermsView[],
    status: ContractStatus,
  }
): ContractLegView {
  return {
    contractLeg: input.contractLeg,
    subtype: input.subtype,
    terms: input.terms,
    status: input.status,
  };
}

const ContractLegView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLeg","default":{"kind":"nothing"},"name":"contractLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLeg"}},"parameters":[]}]}},{"annotations":[],"serializedName":"subtype","default":{"kind":"nothing"},"name":"subtype","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractSubtypeView"}},"parameters":[]}},{"annotations":[],"serializedName":"terms","default":{"kind":"nothing"},"name":"terms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractTermsView"}},"parameters":[]}]}},{"annotations":[{"value":"The leg's current lifecycle status — the latest contract_leg_status row, or ACTIVE if none.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractStatus"}},"parameters":[]}}]}},"name":"ContractLegView","version":{"kind":"nothing"}}};

export const snContractLegView: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"ContractLegView"};

export function texprContractLegView(): ADL.ATypeExpr<ContractLegView> {
  return {value : {typeRef : {kind: "reference", value : snContractLegView}, parameters : []}};
}

export type CheckpointStatus = 'completed' | 'breached' | 'pending' | 'onTrack' | 'atRisk';
export const valuesCheckpointStatus : CheckpointStatus[] = ['completed', 'breached', 'pending', 'onTrack', 'atRisk'];

const CheckpointStatus_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"Where a milestone stands as of the evaluation date.\n - completed: the target was met (including ahead of the milestone's byDate).\n - breached:  not met and due (asOf >= byDate).\n - onTrack:   not met, still to come; at the current sale rate the target is projected to be met.\n - atRisk:    not met, still to come; at the current sale rate the target is projected to be missed.\n - pending:   not met, still to come, and the term hasn't started by asOf — nothing to project from yet.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"breached","default":{"kind":"nothing"},"name":"breached","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"pending","default":{"kind":"nothing"},"name":"pending","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"onTrack","default":{"kind":"nothing"},"name":"onTrack","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"atRisk","default":{"kind":"nothing"},"name":"atRisk","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CheckpointStatus","version":{"kind":"nothing"}}};

export const snCheckpointStatus: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CheckpointStatus"};

export function texprCheckpointStatus(): ADL.ATypeExpr<CheckpointStatus> {
  return {value : {typeRef : {kind: "reference", value : snCheckpointStatus}, parameters : []}};
}

export interface CheckpointEvaluation {
  milestoneId: CompletionMilestoneId;
  byDate: common.LocalDate;
  /**
   * The milestone's cumulativeAmount — units that should be sold by `byDate`.
   */
  targetAmount: common.BigDecimal;
  /**
   * Units sold to date: the leg's stockQuantity less its remaining ledger stock balance.
   */
  completedAmount: common.BigDecimal;
  /**
   * Pro-rata projection of units sold by `byDate` at the current sale rate; set only for a
   * not-yet-met, not-yet-due milestone that has a run-rate to project from (onTrack / atRisk).
   */
  projectedAmount: (common.BigDecimal|null);
  status: CheckpointStatus;
}

export function makeCheckpointEvaluation(
  input: {
    milestoneId: CompletionMilestoneId,
    byDate: common.LocalDate,
    targetAmount: common.BigDecimal,
    completedAmount: common.BigDecimal,
    projectedAmount: (common.BigDecimal|null),
    status: CheckpointStatus,
  }
): CheckpointEvaluation {
  return {
    milestoneId: input.milestoneId,
    byDate: input.byDate,
    targetAmount: input.targetAmount,
    completedAmount: input.completedAmount,
    projectedAmount: input.projectedAmount,
    status: input.status,
  };
}

const CheckpointEvaluation_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"milestoneId","default":{"kind":"nothing"},"name":"milestoneId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CompletionMilestoneId"}},"parameters":[]}},{"annotations":[],"serializedName":"byDate","default":{"kind":"nothing"},"name":"byDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"The milestone's cumulativeAmount — units that should be sold by `byDate`.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"targetAmount","default":{"kind":"nothing"},"name":"targetAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Units sold to date: the leg's stockQuantity less its remaining ledger stock balance.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"completedAmount","default":{"kind":"nothing"},"name":"completedAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Pro-rata projection of units sold by `byDate` at the current sale rate; set only for a\nnot-yet-met, not-yet-due milestone that has a run-rate to project from (onTrack / atRisk).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"projectedAmount","default":{"kind":"nothing"},"name":"projectedAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CheckpointStatus"}},"parameters":[]}}]}},"name":"CheckpointEvaluation","version":{"kind":"nothing"}}};

export const snCheckpointEvaluation: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CheckpointEvaluation"};

export function texprCheckpointEvaluation(): ADL.ATypeExpr<CheckpointEvaluation> {
  return {value : {typeRef : {kind: "reference", value : snCheckpointEvaluation}, parameters : []}};
}

export interface LegCheckpointEvaluation {
  contractLegId: ContractLegId;
  /**
   * The leg's total stock quantity — the denominator behind any cumulative-amount target.
   */
  stockQuantity: common.BigDecimal;
  /**
   * Units sold to date across the whole leg (see CheckpointEvaluation.completedAmount).
   */
  completedAmount: common.BigDecimal;
  checkpoints: CheckpointEvaluation[];
}

export function makeLegCheckpointEvaluation(
  input: {
    contractLegId: ContractLegId,
    stockQuantity: common.BigDecimal,
    completedAmount: common.BigDecimal,
    checkpoints: CheckpointEvaluation[],
  }
): LegCheckpointEvaluation {
  return {
    contractLegId: input.contractLegId,
    stockQuantity: input.stockQuantity,
    completedAmount: input.completedAmount,
    checkpoints: input.checkpoints,
  };
}

const LegCheckpointEvaluation_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}},{"annotations":[{"value":"The leg's total stock quantity — the denominator behind any cumulative-amount target.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"stockQuantity","default":{"kind":"nothing"},"name":"stockQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Units sold to date across the whole leg (see CheckpointEvaluation.completedAmount).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"completedAmount","default":{"kind":"nothing"},"name":"completedAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"checkpoints","default":{"kind":"nothing"},"name":"checkpoints","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CheckpointEvaluation"}},"parameters":[]}]}}]}},"name":"LegCheckpointEvaluation","version":{"kind":"nothing"}}};

export const snLegCheckpointEvaluation: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"LegCheckpointEvaluation"};

export function texprLegCheckpointEvaluation(): ADL.ATypeExpr<LegCheckpointEvaluation> {
  return {value : {typeRef : {kind: "reference", value : snLegCheckpointEvaluation}, parameters : []}};
}

export interface CheckpointLegFilter_LegIds {
  kind: 'legIds';
  value: ContractLegId[];
}
export interface CheckpointLegFilter_OrganisationId {
  kind: 'organisationId';
  value: ferovinum_app_db.OrganisationId;
}

/**
 * Which legs to evaluate: an explicit set, or every stock leg of an organisation.
 */
export type CheckpointLegFilter = CheckpointLegFilter_LegIds | CheckpointLegFilter_OrganisationId;

export interface CheckpointLegFilterOpts {
  legIds: ContractLegId[];
  organisationId: ferovinum_app_db.OrganisationId;
}

export function makeCheckpointLegFilter<K extends keyof CheckpointLegFilterOpts>(kind: K, value: CheckpointLegFilterOpts[K]) { return {kind, value}; }

const CheckpointLegFilter_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[{"value":"Which legs to evaluate: an explicit set, or every stock leg of an organisation.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"legIds","default":{"kind":"nothing"},"name":"legIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"ContractLegId"}},"parameters":[]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}}]}},"name":"CheckpointLegFilter","version":{"kind":"nothing"}}};

export const snCheckpointLegFilter: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"CheckpointLegFilter"};

export function texprCheckpointLegFilter(): ADL.ATypeExpr<CheckpointLegFilter> {
  return {value : {typeRef : {kind: "reference", value : snCheckpointLegFilter}, parameters : []}};
}

export interface EvaluateCheckpointsReq {
  filter: CheckpointLegFilter;
  /**
   * The date to evaluate as of — milestones with `byDate` on or before it are due. Usually today.
   * Not-yet-due, unmet milestones are projected at the current sale rate (onTrack / atRisk).
   */
  asOfDate: common.LocalDate;
}

export function makeEvaluateCheckpointsReq(
  input: {
    filter: CheckpointLegFilter,
    asOfDate: common.LocalDate,
  }
): EvaluateCheckpointsReq {
  return {
    filter: input.filter,
    asOfDate: input.asOfDate,
  };
}

const EvaluateCheckpointsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filter","default":{"kind":"nothing"},"name":"filter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"CheckpointLegFilter"}},"parameters":[]}},{"annotations":[{"value":"The date to evaluate as of — milestones with `byDate` on or before it are due. Usually today.\nNot-yet-due, unmet milestones are projected at the current sale rate (onTrack / atRisk).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"asOfDate","default":{"kind":"nothing"},"name":"asOfDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"EvaluateCheckpointsReq","version":{"kind":"nothing"}}};

export const snEvaluateCheckpointsReq: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EvaluateCheckpointsReq"};

export function texprEvaluateCheckpointsReq(): ADL.ATypeExpr<EvaluateCheckpointsReq> {
  return {value : {typeRef : {kind: "reference", value : snEvaluateCheckpointsReq}, parameters : []}};
}

export interface EvaluateCheckpointsResp {
  legs: LegCheckpointEvaluation[];
}

export function makeEvaluateCheckpointsResp(
  input: {
    legs: LegCheckpointEvaluation[],
  }
): EvaluateCheckpointsResp {
  return {
    legs: input.legs,
  };
}

const EvaluateCheckpointsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.contract","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"legs","default":{"kind":"nothing"},"name":"legs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.contract","name":"LegCheckpointEvaluation"}},"parameters":[]}]}}]}},"name":"EvaluateCheckpointsResp","version":{"kind":"nothing"}}};

export const snEvaluateCheckpointsResp: ADL.ScopedName = {moduleName:"ferovinum.app.contract", name:"EvaluateCheckpointsResp"};

export function texprEvaluateCheckpointsResp(): ADL.ATypeExpr<EvaluateCheckpointsResp> {
  return {value : {typeRef : {kind: "reference", value : snEvaluateCheckpointsResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.contract.ContractKind" : ContractKind_AST,
  "ferovinum.app.contract.ContractLeg" : ContractLeg_AST,
  "ferovinum.app.contract.ContractLegId" : ContractLegId_AST,
  "ferovinum.app.contract.ContractStatus" : ContractStatus_AST,
  "ferovinum.app.contract.ContractLegStatus" : ContractLegStatus_AST,
  "ferovinum.app.contract.ContractLegStatusId" : ContractLegStatusId_AST,
  "ferovinum.app.contract.StockContractLeg" : StockContractLeg_AST,
  "ferovinum.app.contract.StockContractLegEconomics" : StockContractLegEconomics_AST,
  "ferovinum.app.contract.InvoiceContractLeg" : InvoiceContractLeg_AST,
  "ferovinum.app.contract.InvoiceContractLegEconomics" : InvoiceContractLegEconomics_AST,
  "ferovinum.app.contract.AccruingFeeKind" : AccruingFeeKind_AST,
  "ferovinum.app.contract.AccruingFee" : AccruingFee_AST,
  "ferovinum.app.contract.AccruingFeeId" : AccruingFeeId_AST,
  "ferovinum.app.contract.ChargedFeeType" : ChargedFeeType_AST,
  "ferovinum.app.contract.ChargedFee" : ChargedFee_AST,
  "ferovinum.app.contract.ChargedFeeId" : ChargedFeeId_AST,
  "ferovinum.app.contract.ContractTerms" : ContractTerms_AST,
  "ferovinum.app.contract.ContractTermsId" : ContractTermsId_AST,
  "ferovinum.app.contract.EventFeeKind" : EventFeeKind_AST,
  "ferovinum.app.contract.EventFee" : EventFee_AST,
  "ferovinum.app.contract.EventFeeId" : EventFeeId_AST,
  "ferovinum.app.contract.CompletionMilestone" : CompletionMilestone_AST,
  "ferovinum.app.contract.CompletionMilestoneId" : CompletionMilestoneId_AST,
  "ferovinum.app.contract.AccruingFeeDef" : AccruingFeeDef_AST,
  "ferovinum.app.contract.EventFeeDef" : EventFeeDef_AST,
  "ferovinum.app.contract.CompletionMilestoneDef" : CompletionMilestoneDef_AST,
  "ferovinum.app.contract.ContractTermsDef" : ContractTermsDef_AST,
  "ferovinum.app.contract.StockContractLegDef" : StockContractLegDef_AST,
  "ferovinum.app.contract.StockContractLegEconomicsDef" : StockContractLegEconomicsDef_AST,
  "ferovinum.app.contract.InvoiceContractLegDef" : InvoiceContractLegDef_AST,
  "ferovinum.app.contract.InvoiceContractLegEconomicsDef" : InvoiceContractLegEconomicsDef_AST,
  "ferovinum.app.contract.ContractSubtypeDef" : ContractSubtypeDef_AST,
  "ferovinum.app.contract.CreateContractLegReq" : CreateContractLegReq_AST,
  "ferovinum.app.contract.CreateContractLegResp" : CreateContractLegResp_AST,
  "ferovinum.app.contract.ReviseContractTermsReq" : ReviseContractTermsReq_AST,
  "ferovinum.app.contract.ReviseContractTermsResp" : ReviseContractTermsResp_AST,
  "ferovinum.app.contract.ContractTermsView" : ContractTermsView_AST,
  "ferovinum.app.contract.StockContractLegView" : StockContractLegView_AST,
  "ferovinum.app.contract.InvoiceContractLegView" : InvoiceContractLegView_AST,
  "ferovinum.app.contract.ContractSubtypeView" : ContractSubtypeView_AST,
  "ferovinum.app.contract.ContractLegView" : ContractLegView_AST,
  "ferovinum.app.contract.CheckpointStatus" : CheckpointStatus_AST,
  "ferovinum.app.contract.CheckpointEvaluation" : CheckpointEvaluation_AST,
  "ferovinum.app.contract.LegCheckpointEvaluation" : LegCheckpointEvaluation_AST,
  "ferovinum.app.contract.CheckpointLegFilter" : CheckpointLegFilter_AST,
  "ferovinum.app.contract.EvaluateCheckpointsReq" : EvaluateCheckpointsReq_AST,
  "ferovinum.app.contract.EvaluateCheckpointsResp" : EvaluateCheckpointsResp_AST
};
